module.exports = __webpack_public_path__ + "img/home-06-compare-01.f667c69f.jpg";